import { Koi } from '@ksyos/koi';
import type { IPatientContactDetails } from '@common/interfaces/patientContactDetails';
import type { IAddress } from '@common/utils/getFormattedAddress';
import { addressValidationDraftSchema, addressValidationFinalSchema } from '../address';
import { onePhoneNumberRequiredSchema } from '../schemas';
import { emailSchema } from '../schemas/emailSchema';
import { getTextAreaStringSchema } from '../utils/getTextAreaStringSchema';

export type PatientAlternativeAddressType = {
    alternativeAddress: IAddress;
    sendToAlternativeAddress: boolean;
};

export type PatientContactDetailsWithAlternativeAddress = IPatientContactDetails & PatientAlternativeAddressType;

export const patientPhoneAndEmailDraftSchema = Koi.object().keys({
    emailAddress: emailSchema.allow(null),
    homePhoneNumber: getTextAreaStringSchema(true, 255),
    mobileNumber: getTextAreaStringSchema(true, 255),
});

export const patientPhoneAndEmailFinalSchema = Koi.object()
    .keys({
        emailAddress: emailSchema,
    })
    .concat(onePhoneNumberRequiredSchema('homePhoneNumber', 'mobileNumber'));

export const patientContactDetailsDraftSchema = patientPhoneAndEmailDraftSchema.concat(addressValidationDraftSchema);
export const patientContactDetailsFinalSchema = patientPhoneAndEmailFinalSchema.concat(addressValidationFinalSchema);
export const sendToAlternativeAddressSchema = Koi.boolean().allow(null);

export const patienAlternativeAddressDraftSchema = addressValidationDraftSchema;
export const patientAlternativeAddressFinalSchema = Koi.when('sendToAlternativeAddress', {
    is: true,
    otherwise: addressValidationDraftSchema,
    then: addressValidationFinalSchema,
});
